import React from 'react'
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect'

const DefaultProfileImage = ({fontSize = '13', avatar = '', firstName, lastName}) => {

  const selectUserState = createSelector(state => state.Login, state => state.user);
  const user = useSelector(selectUserState);
  return (
    <div className={`avatar-title rounded-circle header-profile-user fs-${fontSize} ${avatar}`}>
      {firstName.slice(0, 1).toUpperCase() + lastName.slice(0, 1).toUpperCase()}
    </div>
  )
}

export default DefaultProfileImage
